import styled from 'styled-components';
import { COLORS, pickThemeFontStyles } from '@/theme';

export const StyledCard = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${COLORS.WHITE};
  border: 1px solid ${COLORS.COLOR_BORDER_SECONDARY};
  border-radius: 0.875rem;
  overflow: hidden;
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.04);
`;

export const StyledCardHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.875rem 1.25rem;
  border-bottom: 1px solid ${COLORS.COLOR_BORDER_SECONDARY};
`;

export const StyledCardBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1rem 1.125rem;
`;

export const StyledCardTitle = styled.h3`
  margin: 0;
  ${pickThemeFontStyles('15', '20', 'BOLD')}
  color: ${COLORS.TEXT_PRIMARY};
`;
